import React, { useState, useEffect } from "react";
import axios from "axios";
import colors from "../Constants/colors"; // same color system used in Dashboard

function CourseMaterial() {
  const [courseMaterials, setCourseMaterials] = useState([]);
  const [form, setForm] = useState({
    title: "",
    subjectName: "",
    className: "",
    sectionName: "",
    file: null,
    description: "",
  });
  const [editingId, setEditingId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [teacher, setTeacher] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const labelStyle = "text-black font-semibold mb-1 !text-[18px]";
  const inputStyle =
    "border rounded-lg px-3 py-2 outline-none !text-[14px] placeholder:!text-[14px] focus:ring-2 focus:ring-blue-500";

useEffect(() => {
  const fetchTeacher = async () => {
    try {
      // Get teacher and session from localStorage
      const teacherRaw = localStorage.getItem("teacher");
      const sessionId = localStorage.getItem("currentSessionId");

      if (!teacherRaw || !sessionId) {
        console.error("Missing teacher or session info in localStorage.");
        return;
      }

      const teacherData = JSON.parse(teacherRaw);
      const teacherId = teacherData.id;

      if (!teacherId) {
        console.error("Teacher ID missing in localStorage data.");
        return;
      }

      // Fetch teacher info from backend
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
        { params: { sessionId } }
      );

      const teacher = res.data;
      setTeacher(teacher);

      // Fetch classes if teacher has a name
      if (teacher.firstName && teacher.lastName) {
        fetchClasses(`${teacher.firstName} ${teacher.lastName}`);
      }

    } catch (err) {
      console.error("Error fetching teacher:", err.response?.data || err.message);
    }
  };

  fetchTeacher();
}, []);


  useEffect(() => {
    fetchCourseMaterials();
  }, []);
const sessionId = localStorage.getItem("currentSessionId");
  const fetchClasses = async (teacherName) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getTeacherClasses/${teacherName}`,
        { params: { sessionId } }
      );
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const fetchSubjects = async (className) => {
    if (!teacher) return;
    try {
      const { firstName, lastName } = teacher;
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/timetable/getSubjectsByTeacherAndClass/${firstName}%20${lastName}/${className}`,
        { params: { sessionId } }
      );
      setSubjects(Array.isArray(res.data.subjects) ? res.data.subjects : []);
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  const fetchCourseMaterials = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/coursematerial/getAllCourseMaterials`,
        { params: { sessionId } }
      );
      setCourseMaterials(res.data);
    } catch (error) {
      console.error("Error fetching materials:", error);
    }
  };

  useEffect(() => {
    if (form.className) fetchSubjects(form.className);
  }, [form.className]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "className") {
      const [cls, section] = value.split("|");
      setForm({ ...form, className: cls, sectionName: section });
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleFileChange = (e) => {
    setForm({ ...form, file: e.target.files[0] });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  Object.entries(form).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      fd.append(key, value);
    }
  });

  // Append sessionId from localStorage
  const sessionId = localStorage.getItem("currentSessionId");
  if (!sessionId) {
    alert("Session ID missing. Please login again.");
    return;
  }
  fd.append("sessionId", sessionId);

  setIsLoading(true);

  try {
    if (editingId) {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/coursematerial/updateCourseMaterial/${editingId}`,
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert("Course material updated successfully!");
    } else {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/coursematerial/createCourseMaterial`,
        fd,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      alert("Course material created successfully!");
    }

    clearForm();
    fetchCourseMaterials();
  } catch (err) {
    console.error("Error saving course material:", err.response?.data || err.message);
    alert("Error saving course material. Check console for details.");
  } finally {
    setIsLoading(false);
  }
};


  const clearForm = () => {
    setForm({
      title: "",
      subjectName: "",
      className: "",
      sectionName: "",
      file: null,
      description: "",
    });
    setEditingId(null);
  };

  const handleEdit = (item) => {
    setForm({
      title: item.title || "",
      subjectName: item.subjectName || "",
      className: item.className || "",
      sectionName: item.sectionName || "",
      file: null,
      description: item.description || "",
    });
    setEditingId(item._id);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this course material?")) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_BASE_URL}/api/coursematerial/deleteCourseMaterial/${id}`,
          { params: { sessionId } }
        );
        fetchCourseMaterials();
      } catch (err) {
        console.error("Error deleting:", err);
      }
    }
  };

  const getFiltered = () =>{
    if (!form.className || !form.subjectName) return [];
    return courseMaterials.filter(
      (m) =>
        (!form.className || m.className === form.className) &&
        (!form.sectionName || m.sectionName === form.sectionName) &&
        (!form.subjectName || m.subjectName === form.subjectName)
    );
  }
    

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <i className="fas fa-book-open text-red-500 !text-[20px]" />
          <h1 className="font-bold !text-[18px]">Course Materials</h1>
        </div>
        {editingId && (
          <span className="text-sm text-gray-500">
            Editing material – <span className="font-semibold">Update mode</span>
          </span>
        )}
      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="space-y-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Class */}
          <div className="flex flex-col">
            <label className={labelStyle}>Class:</label>
            <select
              name="className"
              value={
                form.className && form.sectionName
                  ? `${form.className}|${form.sectionName}`
                  : ""
              }
              onChange={handleInputChange}
              required
              className={inputStyle}
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option
                  key={cls._id}
                  value={`${cls.className}|${cls.sectionName}`}
                >
                  {cls.className} ({cls.sectionName})
                </option>
              ))}
            </select>
          </div>

          {/* Subject */}
          <div className="flex flex-col">
            <label className={labelStyle}>Subject:</label>
            <select
              name="subjectName"
              value={form.subjectName}
              onChange={handleInputChange}
              required
              disabled={!form.className}
              className={inputStyle}
            >
              <option value="">Select Subject</option>
              {subjects.map((sub, i) => (
                <option key={i} value={sub}>
                  {sub}
                </option>
              ))}
            </select>
          </div>

          {/* Title */}
          <div className="flex flex-col">
            <label className={labelStyle}>Title:</label>
            <input
              type="text"
              name="title"
              value={form.title}
              onChange={handleInputChange}
              required
              placeholder="Enter material title"
              className={inputStyle}
            />
          </div>

          {/* File */}
          <div className="flex flex-col">
            <label className={labelStyle}>Upload File:</label>
            <input
              type="file"
              name="file"
              onChange={handleFileChange}
              required={!editingId}
              className={inputStyle}
            />
          </div>

          {/* Description */}
          <div className="flex flex-col md:col-span-2">
            <label className={labelStyle}>Description:</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleInputChange}
              className={`${inputStyle} min-h-[80px] resize-y`}
              rows="2"
              placeholder="Enter short description (optional)"
            />
          </div>
        </div>

        {/* ACTION BUTTONS */}
        <div className="flex justify-start gap-4 mt-4">
          <button
            type="submit"
            disabled={isLoading}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg !text-[14px] disabled:opacity-70"
          >
            {isLoading
              ? "Saving..."
              : editingId
              ? "Update Material"
              : "Add Material"}
          </button>

          {editingId && (
            <button
              type="button"
              onClick={clearForm}
              className="bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg !text-[14px]"
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* TABLE / LIST CARD */}
      <div className="bg-white shadow-lg rounded-lg p-6">
        <h2 className="font-semibold mb-4 flex items-center gap-2 !text-[18px] text-gray-900">
          <i className="fas fa-folder-open text-blue-500 !text-[18px]" />
          Materials
        </h2>

        {/* Desktop Table */}
        <div className="overflow-x-auto hidden md:block">
          <table className="min-w-full border border-gray-300 text-center !text-[14px]">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                {["#", "Class", "Subject", "Title", "File", "Actions"].map(
                  (h) => (
                    <th
                      key={h}
                      className="px-4 py-2 border font-semibold whitespace-nowrap"
                    >
                      {h}
                    </th>
                  )
                )}
              </tr>
            </thead>
            <tbody className="bg-white">
              {getFiltered().length ? (
                getFiltered().map((m, i) => (
                  <tr
                    key={m._id}
                    className="hover:bg-gray-50 border-b transition-colors"
                  >
                    <td className="px-4 py-2 border">{i + 1}</td>
                    <td className="px-4 py-2 border">
                      {m.className} ({m.sectionName})
                    </td>
                    <td className="px-4 py-2 border">{m.subjectName}</td>
                    <td className="px-4 py-2 border">{m.title}</td>
                    <td className="px-4 py-2 border">
                      <a
                        href={m.courseMaterialFile}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        View
                      </a>
                    </td>
                    <td className="px-4 py-2 border">
                      <div className="flex justify-center gap-3">
                        <button
                          onClick={() => handleEdit(m)}
                          className="text-yellow-600 hover:underline"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(m._id)}
                          className="text-red-600 hover:underline"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="6"
                    className="py-3 text-gray-500 text-center border"
                  >
                    No materials found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="grid grid-cols-1 md:hidden gap-4">
          {getFiltered().length ? (
            getFiltered().map((m) => (
              <div
                key={m._id}
                className="border rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition"
              >
                <h3 className="font-bold !text-[16px] mb-1 flex items-center gap-2">
                  <i className="fas fa-file-alt text-yellow-700" />
                  {m.title}
                </h3>
                <p className="!text-[14px] mb-1">
                  <i className="fas fa-chalkboard-teacher text-blue-600 mr-2" />
                  {m.className} ({m.sectionName})
                </p>
                <p className="!text-[14px] mb-2">
                  <i className="fas fa-book text-green-600 mr-2" />
                  {m.subjectName}
                </p>
                <div className="flex justify-between items-center mt-3 !text-[14px]">
                  <a
                    href={m.courseMaterialFile}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    <i className="fas fa-eye mr-1" />
                    View
                  </a>
                  <button
                    onClick={() => handleEdit(m)}
                    className="text-yellow-600 hover:underline"
                  >
                    <i className="fas fa-edit mr-1" />
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(m._id)}
                    className="text-red-600 hover:underline"
                  >
                    <i className="fas fa-trash mr-1" />
                    Delete
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 !text-[14px]">
              No course materials found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default CourseMaterial;
